import {Stage} from "./base/Display2D.js";

import {Site} from "./site/Site.js";
import {Navigation} from "./site/Navigation.js";

//
// setup
//

!function setUpContent () {
	window.Navigation = Navigation;
	
	function startUp () {
		const tables = document.querySelectorAll ("main .table table");
		
		for (let i = tables.length; i--;) {
			const table = tables [i];
			
			const headerCells = table.querySelectorAll ("th");
			const tableCells = table.querySelectorAll ("td");
			
			for (let i = tableCells.length; i--;) {
				const tableCell = tableCells [i];
				
				if (tableCell.textContent.trim ())
					tableCell.setAttribute ("data-label",
						headerCells [i % headerCells.length].textContent);
				
				if (!i)
					tableCell.setAttribute ("firstchild", "yes");
				
			}
			
		}
		
		var controllerElement = document.querySelector ("header");
		if (controllerElement) {
			var controller = Stage.fromElement.call (
				Navigation, controllerElement
				
			);
			
		}
		
		var controllerElement = document.querySelector ("main") || document.body;
		if (controllerElement) {
			var controller = Stage.fromElement.call (
				Site, controllerElement
				
			);
			
		}
		
	}
	
	window.addEventListener ("DOMContentLoaded", startUp);
	
} ();
